
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.9999 13.66V8.99C17.9999 7.99 16.9899 6.99 15.9999 7V4C15.9999 3.45 15.5499 3 14.9999 3C14.4499 3 13.9999 3.45 13.9999 4V7H10.1199L17.7499 14.63C17.8999 14.33 17.9999 14 17.9999 13.66ZM9.99994 4C9.99994 3.45 9.54994 3 8.99994 3C8.44994 3 7.99994 3.45 7.99994 4V4.88L9.99994 6.88V4ZM20.1499 19.86L12.4899 12.2L7.38994 7.1L4.82994 4.54C4.43994 4.15 3.80994 4.15 3.41994 4.54C3.02994 4.93 3.02994 5.56 3.41994 5.95L6.04994 8.58C6.01994 8.71 5.99994 8.85 5.99994 8.99V13.65C5.99994 14.18 6.20994 14.69 6.57994 15.06L9.49994 18V20C9.49994 20.55 9.94994 21 10.4999 21H13.4999C14.0499 21 14.4999 20.55 14.4999 20V18L14.9799 17.52L18.7399 21.28C19.1299 21.67 19.7599 21.67 20.1499 21.28C20.5399 20.89 20.5399 20.25 20.1499 19.86Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-power-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPowerOff

    ```js
    <b-new-b-icon-power-off />
    ```
</docs>


